import { MotionValue } from "motion/react";
import { createContext, useContext } from "react";

export type ScrollProgressContextValue = {
  scrollXProgress: MotionValue<number>;
  scrollYProgress: MotionValue<number>;
  type: "window" | "container";
  container?: HTMLElement | null;
};

export const ScrollProgressContext =
  createContext<ScrollProgressContextValue | null>(null);

export function useScrollProgress(): ScrollProgressContextValue {
  // 拿到最近一层 Provider
  const ctx = useContext(ScrollProgressContext);
  if (!ctx) {
    throw new Error(
      "useScrollProgress must be used inside ScrollProgressContext.Provider"
    );
  }
  return ctx;
}
